import {createRouter, createWebHistory} from 'vue-router';
import AuthService from "@/services/auth.service";
import {auth} from "@/store/auth.module";

const Login = () => import('./components/Login.vue');
const Register = () => import('./components/Register.vue');
const Profile = () => import('./components/Profile.vue');
const Dashboard = () => import('./components/Dashboard.vue');
const Item = () => import('./components/Item.vue');
const Store = () => import('./components/Store.vue');
const ItemAdjustment = () => import('./components/ItemAdjustment.vue');
const ItemRecipe = () => import('./components/ItemRecipe.vue');
const ItemTransRawMaterialReceive = () => import('./components/ItemTransRawMaterialReceive.vue');
const ItemTransIssuance = () => import('./components/ItemTransIssuance.vue');
const ItemTransProcessing = () => import('./components/ItemTransProcessing.vue');
const ItemTransFinishGoodReceive = () => import('./components/ItemTransFinishGoodReceive.vue');
const ReportParameterForm = () => import('./components/ReportParameterForm.vue');
const Report = () => import('./components/Report.vue');
const ChangePassword = () => import('./components/ChangePassword.vue');
const CompanyManagement = () => import('./components/CompanyManagement.vue');

const routes = [
  {
    path: "/",
    alias: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/register",
    component: Register
  },
  {
    path: "/profile",
    component: Profile
  },
  {
    path: "/items",
    alias: "/items",
    name: "Item",
    component: Item
  },
  {
    path: "/stores",
    alias: "/stores",
    name: "Store",
    component: Store
  },
  {
    path: "/item-adjustments",
    alias: "/item-adjustments",
    name: "ItemAdjustment",
    component: ItemAdjustment
  },
  {
    path: "/item-recipes",
    alias: "/item-recipes",
    name: "ItemRecipe",
    component: ItemRecipe
  },
  {
    path: "/raw-material-receive",
    alias: "/raw-material-receive",
    name: "ItemTransRawMaterialReceive",
    component: ItemTransRawMaterialReceive
  },
  {
    path: "/issuance",
    alias: "/issuance",
    name: "ItemTransIssuance",
    component: ItemTransIssuance
  },
  {
    path: "/processing",
    alias: "/processing",
    name: "ItemTransProcessing",
    component: ItemTransProcessing
  },
  {
    path: "/finish-good-receive",
    alias: "/finish-good-receive",
    name: "ItemTransFinishGoodReceive",
    component: ItemTransFinishGoodReceive
  },
  {
    path: "/param-form",
    alias: "/param-form",
    name: "ReportParameterForm",
    component: ReportParameterForm
  },
  {
    path: "/reports",
    alias: "/reports",
    name: "JasperReports",
    component: Report,
  },
  {
    path: "/change-password",
    alias: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
  },
  {
    path: "/companies",
    alias: "/companies",
    name: "CompanyManagement",
    component: CompanyManagement,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, _from, next) => {
  const publicPages = auth.publicPages;
  const authRequired = !publicPages.includes(to.path);
  let isLoggedIn = null;
  const authorization = JSON.parse(localStorage.getItem('authorization'));
  if (authorization) {
    isLoggedIn = await AuthService.isTokenValid({jwt: authorization.accessToken});
  }
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !isLoggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;